export default {
    showPopup: (state) => {
        return !!state.payload
    },
    payload: (state) => {
        return state.payload || {}
    }
}
